<div class="flex flex-row items-stretch pt-20 pb-24 px-10 h-full">
  <div class="flex flex-col bg-zen bg-opacity-5 rounded-lg border border-zen border-opacity-20 items-center justify-center gap-5 w-full py-20">
    <h5 class="text-lg text-center px-5 bg-exp text-exp bg-opacity-10 py-1 rounded mt-2">{{ "txtThisDemoAccount" |
      translate:language:ModuleNames.Shared }}</h5>
    <h5 class="text-2xl text-center w-full text-zen-lite">{{ "txtDemoSection" | translate:language:ModuleNames.Shared }}
    </h5>
  </div>

</div>
